<template>
  <div class="viz-navigator" v-resize="onResize" ref="component">
    <div
      class="viz-navigator-el"
      :class="{ disabled: getVizElSelected === null }"
    >
      <div class="viz-navigator-el-content" @click="resetQuery()">
        <span>{{ $ml.get("dataviz").title }}</span>
      </div>

      <div :class="['viz-navigator-el-background']"></div>
    </div>
    <div
      class="viz-navigator-el"
      v-for="(el, elIndex) in ancestors"
      :key="elIndex"
    >
      <div
        class="viz-navigator-el-arrow viz-navigator-el-arrow-top"
        v-if="
          ancestors.length > 0 && elIndex === ancestors.length - 1 && !isGallery
        "
        @click="changeGroup(el, 'prev')"
      >
        <svgicon
          class="arrow"
          icon="icon-arrow-down"
          width="15"
          height="15"
        ></svgicon>
      </div>
      <div
        :class="{
          'viz-navigator-el-content': true,
          'last-el':
            ancestors.length > 0 &&
            elIndex === ancestors.length - 1 &&
            !isGallery
        }"
        @click="setQuery(el.depth, el.data.id)"
      >
        <span
          :class="{
            'last-el':
              ancestors.length > 0 &&
              elIndex === ancestors.length - 1 &&
              !isGallery
          }"
          >{{ el.data.name }}</span
        >
      </div>
      <div
        class="viz-navigator-el-arrow viz-navigator-el-arrow-bottom"
        v-if="
          ancestors.length > 0 && elIndex === ancestors.length - 1 && !isGallery
        "
        @click="changeGroup(el, 'next')"
      >
        <svgicon
          class="arrow"
          icon="icon-arrow-down"
          width="15"
          height="15"
        ></svgicon>
      </div>
      <div
        :class="['viz-navigator-el-background']"
        :style="{
          top: setTop(el) + 'px',
          height: setHeight(el) + 'px',
          transitionDuration: 800 / 1000 + 's'
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import genericQueryMethods from "@/mixins/genericQueryMethods";
import resize from "vue-resize-directive";
import * as d3Scale from "d3-scale";
import "@/compiled-icons/icon-arrow-down";
import "@/compiled-icons/icon-arrow-up";
export default {
  mixins: [genericQueryMethods],
  props: ["isGallery"],
  data() {
    return {
      width: 0,
      height: 0,
      baseUrl: process.env.BASE_URL
    };
  },
  computed: {
    ancestors() {
      if (!this.getVizElSelected) {
        return [];
      } else {
        let res = this.getVizElSelected.ancestors();

        return this.isGallery
          ? res.reverse().slice(1, res.length - 1)
          : res.reverse().slice(1, res.length);
      }
    },
    ...mapGetters(["getVizElSelected", "getFilterViz", "hierarchyData"])
  },
  methods: {
    changeGroup(el, direction) {
      let depth = el.depth;

      let sameDepth = [];
      this.hierarchyData.each(o => {
        if (o.depth === depth) sameDepth.push(o);
      });
      let index = _.findIndex(sameDepth, o => o.data.id === el.data.id);
      let res;
      if (direction === "prev") {
        res = index > 0 ? index - 1 : index;
      } else {
        res = sameDepth[index + 1] ? index + 1 : index;
      }

      this.setQuery(
        this.getVizElSelected.depth,
        sameDepth[res].children[0].data.id
      );
    },
    setTop(el) {
      let min = el.data.progress[this.getFilterViz];
      let max =
        el.data.progress[this.getFilterViz] + el.data.weight[this.getFilterViz];

      let scale = d3Scale
        .scaleLinear()
        .domain([min, max])
        .range([0, this.height]);
      return scale(0);
    },
    setHeight(el) {
      let max = el.data.weight[this.getFilterViz];
      let scale = d3Scale
        .scaleLinear()
        .domain([0, max])
        .range([0, this.height]);
      return scale(this.hierarchyData.data.weight[this.getFilterViz]);
    },
    setDimensions() {
      const component = this.$refs.component;
      this.width = component.getBoundingClientRect().width;
      this.height = component.getBoundingClientRect().height;
    },
    onResize() {
      this.setDimensions();
    }
  },
  directives: {
    resize
  }
};
</script>

<style lang="scss" scoped>
.viz-navigator {
  margin-left: 35px;
  height: 100vh;
  display: flex;
  &-el {
    height: 100%;
    width: 35px;
    display: flex;
    align-items: space-between;
    flex-direction: column;
    justify-content: center;

    position: relative;

    &.disabled {
      pointer-events: none;
    }
    &-content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      color: $white-70;
      overflow: hidden;
      border-right: 1px solid $white;
      user-select: none;
      &.last-el {
        overflow: visible;
        border-right: none;
      }
      &:hover:not(.last-el) {
        background: rgba(255, 255, 255, 0.2);
        cursor: pointer;
        span {
          color: $white;
        }
      }

      span {
        display: inline-block;
        @include ButtonS;
        transform: rotate(-90deg);
        z-index: 1;
        color: $white-70;
        white-space: nowrap;

        &.last-el {
          color: $white;
          pointer-events: none;
        }
      }
    }

    &-arrow {
      width: 100%;
      height: 35px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(180deg);
      z-index: 1;
      cursor: pointer;
      border-top: 1px solid $white-50;
      fill: $white-70;
      &-bottom {
        transform: rotate(0deg);
      }
      &-top {
      }
      &:hover {
        fill: $white;
        background: rgba(255, 255, 255, 0.1);
      }
    }

    &-background {
      position: absolute;
      width: 100vw;
      top: 0;
      height: 100%;
      left: 0;
      z-index: $z-none;

      background: linear-gradient(
        180deg,
        #96c2c4 -3.84%,
        #bea95e 49.07%,
        #573c46 106.58%
      );
      // transition: top 0.8s ease, height 0.8s ease;
    }
    &:last-of-type {
      overflow: visible;
      .viz-navigator-el-background {
        width: 100vw;
      }
    }
  }
}
</style>
